import { render, staticRenderFns } from "./cards-grid.vue?vue&type=template&id=513f3720&scoped=true&"
import script from "./cards-grid.vue?vue&type=script&lang=js&"
export * from "./cards-grid.vue?vue&type=script&lang=js&"
import style0 from "./cards-grid.vue?vue&type=style&index=0&id=513f3720&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513f3720",
  null
  
)

export default component.exports